<ng-container>
  <ng-template #tooltip>
    <ng-content select="[tooltip]"></ng-content>
  </ng-template>

  <div [ngbTooltip]="tooltip" [triggers]="triggers" [placement]="placement">
    <ng-content select="[body]"></ng-content>
  </div>
</ng-container>